const siteConfig = {
  isCallUsEnabled: true,
  isEmailUsEnabled: false,
  isPayPalEnabled: true,
  isSocailShareEnabled: true,
  isContactUsFormEnabled: true,
  isSupportTicketsEnabled: true,
  isProductCompareEnabled: true,
  isWriteUsEnabled: true,
  isProductIdEnabled: true,
  showInStockMsg: true,
  showProductFeatures: true,
  showProductSpecs: true,
  showProductResources: true,
  isSaveCartEnabled: true,
  isMultipleShippingEnabled: true,
  showDeliveryInstructions: true,
  isDinersCardAvailable: true,
  showProductIndicators: false,
  isGiftingEnabled: true,
  isGooglePayEnabled: true,
  isApplePayEnabled: true,
  isVariantsEnabled: true,
  isProductPriceEnabled: true,
  addToCartEnabled: true,
  promoTextEnabled: true,
  showProductStatus: true,
  isQuantitySelectorEnabled: true,
  isMobileMyProfileEnabled: true,
  pdpLocateAStoreEnabled: false,
  showPoBoxShippingMsg: true,
  showInventoryMessages: true,
  isFindADistributorEnabled: false,
  showForgotPassword: true,
  createAcountMoreDetailsEnabled: false,
  editPasswordEnabled: true,
  editCommPrefEnabled: true,
  hasTaxExemption: false,
  addAddressEnabled: true,
  deleteAddressEnabled: false,
  addPaymentEnabled: true,
  deletePaymentEnabled: true,
  is3DImageEnabled: true,
  reorderEnabled: false,
  addCustomAttrs: false,
  addToListBySku: false,
  downloadPrdListInfo: false,
  downloadListPdf: false,
  downloadListImage: false,
  downloadPdpPdf: true,
  downloadPdpImage: true,
  hasCmirCode: false,
  isFindAStoreEnabled: true,
  showLowInventoryMessage: true,
  isReferAFriend: false,
  pdpimageOrVideoConstraintEnabled: false,
  isCategoryDescriptionEnabled: true,
  isSlashedPriceEnabled: true,
};

export default siteConfig;



// WEBPACK FOOTER //
// ./src/config/aria-config.js